/**
 * Telehealth API - Video conferencing endpoints
 *
 * Enhances the generated telehealth API with cache management and user-friendly hook names.
 * Backend handles Daily.co integration - we just need appointment ID to get join link.
 */

import { enhancedApi } from '@store/generated/telehealth';

/**
 * Feature-specific tag types for cache management
 */
const TELEHEALTH_TAG_TYPES = ['TelehealthSession'] as const;

/**
 * Telehealth API with enhanced endpoints
 */
export const telehealthApi = enhancedApi.enhanceEndpoints({
  addTagTypes: TELEHEALTH_TAG_TYPES,
  endpoints: {
    postV2ProviderTelehealthJoinLink: {
      invalidatesTags: [{ type: 'TelehealthSession', id: 'LIST' }],
    },
  },
});

/**
 * Export ONLY user-friendly hook names
 */
export const {
  usePostV2ProviderTelehealthJoinLinkMutation: useCreateProviderJoinLink,
} = telehealthApi;
